import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { Grid } from '@mui/material';
import { AppWebsiteVisits } from '../sections/@dashboard/app';
import CompanyDashboard from '../components/CompanyDashboard';

import {
  Card,
  Container,
  Typography,
  Box
} from '@mui/material';

import axios from "axios";

import {
  AppWidgetSummary,
  AppCurrentVisits,
} from '../sections/@dashboard/app';

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

import { LoadScript } from "@react-google-maps/api";
import GoogleMapZoneComponent from '../components/GoogleMapZoneComponent';

export default function DashboardAppPage() {

  const [zones, setZones] = useState([]);
  const [zonesdataloaded, setZonesDataLoaded] = useState(false);

  const [selectedLamp, setSelectedLamp] = useState(null);
  const [selectedZoneId, setSelectedZoneId] = useState(null);

  const [mapHeight, setMapHeight] = useState(window.innerHeight * 0.6);

  const { user: currentUser } = useSelector((state) => state.auth);

  const theme = useTheme();
  const isXL = useMediaQuery(theme.breakpoints.up('xl'));
  const isLG = useMediaQuery(theme.breakpoints.up('lg'));
  const isMD = useMediaQuery(theme.breakpoints.up('md'));

  const widgetSize = isXL ? 150 : isLG ? 130 : isMD ? 110 : 90;

  const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER_URL;

  useEffect(() => {
    const handleResize = () => {
      setMapHeight(window.innerHeight * 0.6);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!zonesdataloaded && currentUser) {
      getZones();
    }
  }, [currentUser, zonesdataloaded]);

  const getZones = async () => {
    try {
      const response = await axios.get(SERVER_URL + "/api/zonas");
      setZones(response.data);
      setZonesDataLoaded(true);
    } catch (err) {
      console.log("error");
    }
  };

  const companyStats = zones.reduce((acc, z) => {
    acc.total += z.numbertotal || 0;
    acc.active += z.numberaktivne || 0;
    acc.inactive += z.numberneaktivne || 0;
    acc.alarms += z.numberalarms || 0;
    acc.failed += z.numberfailed || 0;
    return acc;
  }, {
    total: 0,
    active: 0,
    inactive: 0,
    alarms: 0,
    failed: 0
  });

  const companyCharts = zones.reduce((acc, z) => {
    acc.number45w += z.number45w || 0;
    acc.number60w += z.number60w || 0;
    acc.number90w += z.number90w || 0;

    acc.numberaktivne += z.numberaktivne || 0;
    acc.numberneaktivne += z.numberneaktivne || 0;

    acc.januar += z.januar || 0;
    acc.februar += z.februar || 0;
    acc.mart += z.mart || 0;
    acc.april += z.april || 0;
    acc.maj += z.maj || 0;
    acc.juni += z.juni || 0;
    acc.juli += z.juli || 0;
    acc.august += z.august || 0;
    acc.septembar += z.septembar || 0;
    acc.oktobar += z.oktobar || 0;
    acc.novembar += z.novembar || 0;
    acc.decembar += z.decembar || 0;

    return acc;
  }, {
    number45w: 0,
    number60w: 0,
    number90w: 0,
    numberaktivne: 0,
    numberneaktivne: 0,
    januar: 0,
    februar: 0,
    mart: 0,
    april: 0,
    maj: 0,
    juni: 0,
    juli: 0,
    august: 0,
    septembar: 0,
    oktobar: 0,
    novembar: 0,
    decembar: 0
  });

  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_API_KEY}>
      <Helmet>
        <title> Pametna rasvjeta </title>
      </Helmet>

      <div style={{
        backgroundColor: '#001536',
        paddingTop: '1rem',
        paddingBottom: '1rem',
        minHeight: '100%',
      }}>
        <Container maxWidth="xl" sx={{ color: "#ff9800" }}>

          <CompanyDashboard companyId={1} />

          {/* OSTATak tvog koda ispod — NIJE DIRAN */}

          {false && zones.map((row) => {
            const {
              id, name,
              number45w, number60w, number90w,
              numberaktivne, numberneaktivne,
              januar, februar, mart, april, maj, juni,
              juli, august, septembar, oktobar, novembar, decembar,
              numbertotal, numberfailed, numberalarms
            } = row;

            return (
              <React.Fragment key={id}>

                <Card sx={{ backgroundColor: "#001B44", color: "#ff9800", mb: 3 }}>

                  <Typography
                    sx={{
                      ml: 4,
                      mt: 2,
                      fontSize: '1.5rem',
                      fontWeight: 600
                    }}
                  >
                    Zona: {name}
                  </Typography>

                  {/* MAPA */}
                  <Box sx={{ width: '100%', height: mapHeight }}>
                    <GoogleMapZoneComponent
                      zonaid={id}
                      selectedLamp={selectedLamp}
                      selectedZoneId={selectedZoneId}
                    />
                  </Box>

                  {/* 🔥 WIDGETI ISPOD MAPE */}
                  <Box sx={{ p: 2 }}>
                    <Grid container spacing={3}>

                      <Grid item xs={12} sm={6} md={2}>
                        <AppWidgetSummary
                          title="Total"
                          total={numbertotal}
                          icon={'mdi:counter'}
                          sx={{ transform: `scale(${widgetSize / 250})` }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={2}>
                        <AppWidgetSummary
                          title="Active"
                          total={numberaktivne}
                          color="success"
                          icon={'mdi:check-circle'}
                          sx={{ transform: `scale(${widgetSize / 250})` }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={2}>
                        <AppWidgetSummary
                          title="Inactive"
                          total={numberneaktivne}
                          color="info"
                          icon={'mdi:pause-circle'}
                          sx={{ transform: `scale(${widgetSize / 250})` }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={2}>
                        <AppWidgetSummary
                          title="Alarms"
                          total={numberalarms}
                          color="warning"
                          icon={'mdi:alert'}
                          sx={{ transform: `scale(${widgetSize / 250})` }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={2}>
                        <AppWidgetSummary
                          title="Failed"
                          total={numberfailed}
                          color="error"
                          icon={'mdi:close-circle'}
                          sx={{ transform: `scale(${widgetSize / 250})` }}
                        />
                      </Grid>

                      <Grid item xs={12} sm={6} md={2}>
                        <AppWidgetSummary
                          title="Errors"
                          total={numberfailed}
                          color="error"
                          icon={'mdi:bug'}
                          sx={{ transform: `scale(${widgetSize / 250})` }}
                        />
                      </Grid>

                    </Grid>
                  </Box>

                  {/* GRAFOVI */}
                  <Box sx={{ p: 2 }}>
                    <Grid container spacing={3}>

                      <Grid item xs={12} md={6} lg={3}>
                        <AppCurrentVisits
                          title="Modeli lampi"
                          chartData={[
                            { label: 'S 45 W', value: number45w },
                            { label: 'M 60 W', value: number60w },
                            { label: 'L 90 W', value: number90w },
                          ]}
                          chartColors={[
                            theme.palette.primary.main,
                            theme.palette.info.main,
                            theme.palette.warning.main,
                          ]}
                          chartHeight={200}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <AppCurrentVisits
                          title="Status lampi"
                          chartData={[
                            { label: 'Aktivni', value: numberaktivne },
                            { label: 'Neaktivni', value: numberneaktivne },
                          ]}
                          chartColors={[
                            theme.palette.success.main,
                            theme.palette.error.main,
                          ]}
                          chartHeight={200}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <AppCurrentVisits
                          title="Potrošnja zone"
                          chartData={[
                            { label: 'Januar', value: januar },
                            { label: 'Februar', value: februar },
                            { label: 'Mart', value: mart },
                            { label: 'April', value: april },
                            { label: 'Maj', value: maj },
                            { label: 'Juni', value: juni },
                            { label: 'Juli', value: juli },
                            { label: 'August', value: august },
                            { label: 'Septembar', value: septembar },
                            { label: 'Oktobar', value: oktobar },
                            { label: 'Novembar', value: novembar },
                            { label: 'Decembar', value: decembar },
                          ]}
                          chartColors={[
                            "#1E88E5", "#43A047", "#FB8C00", "#E53935", "#8E24AA", "#00ACC1", "#FDD835", "#6D4C41", "#3949AB", "#5E35B1", "#00897B", "#C0CA33",
                          ]}
                          chartHeight={200}
                        />
                      </Grid>

                      <Grid item xs={12} md={6} lg={3}>
                        <AppCurrentVisits
                          title="Test"
                          chartData={[
                            { label: 'a', value: 1 },
                            { label: 'b', value: 2 },
                            { label: 'b', value: 3 },
                            { label: 'd', value: 4 },
                          ]}
                          chartColors={[
                            theme.palette.primary.main,
                            theme.palette.info.main,
                            theme.palette.warning.main,
                            theme.palette.error.main,
                          ]}
                          chartHeight={200}
                        />
                      </Grid>

                    </Grid>
                  </Box>

                </Card>

              </React.Fragment>
            );
          })}

        </Container>

      </div>
    </LoadScript>
  );
}